import { Core } from '@unseenco/taxi';
import defaultTransition from './defaultTransition.js';
import menuTransition from './menuTransition.js';

let instance;

/**
 * Taxi Declaration
 * @param  {Object} app
 * @returns {Core}
 */
export default function useTaxi(app) {
  if (instance) {
    return instance;
  }

  /**
   * Taxi Core
   */
  instance = new Core({
    transitions: {
      default: defaultTransition(app),
      menuTransition: menuTransition(app),
    },
  });

  return instance;
}
